import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../../apiservices/CasionApi";
import RefResultModal from "../../../casinoComponents/refResultModal";
import Teen20ResultBody from "../../../casinoComponents/refResultModal/Teen20ResultBody";
import { formatRefMatchTime } from "../../../../utils/refMatchTime";

/**
 * Last Result items for 20-20 Teenpatti pages in the reference markup
 * (rendered inside CasinoLastResult's .casino-video-last-results):
 *   span.resulta "A" / span.resultb "B" (win 0 → "T", no class).
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the
 * reference result modal ("{ename} Result", modal-xl, .casino-result).
 */
export default function Teen20RefResults({ gameType = "teen20", fallbackTitle = "20-20 Teenpatti" }) {
  const apiType = String(gameType || "teen20").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {lastResults.map((r, i) => {
        const w = String(r?.win ?? "");
        return (
          <span
            key={`${r?.mid}-${i}`}
            className={w === "1" ? "resulta" : w === "2" ? "resultb" : undefined}
            onClick={() => handleResultClick(r?.mid)}
          >
            {w === "1" ? "A" : null} {w === "2" ? "B" : null} {w === "0" ? "T" : null}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={handleClose}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <Teen20ResultBody t1={detailResult} gameType={apiType} />}
      </RefResultModal>
    </>
  );
}
